import authenticatedRequest from '../authenticatedRequest';
import labelRequest from '../labelRequest';
import querystring from 'query-string';
import invariant from 'invariant';

export default function getEmailChangeToken(params) {
    const { baseUrl, brandId, country, language, uberToken, clientId, clientSecret } = params;

    invariant(baseUrl, 'baseUrl is a required param of getEmailChangeToken()');
    invariant(brandId, 'brandId is a required param of getEmailChangeToken()');
    invariant(country, 'country is a required param of getEmailChangeToken()');
    invariant(language, 'language is a required param of getEmailChangeToken()');
    invariant(uberToken, 'uberToken is a required param of getEmailChangeToken()');
    invariant(clientId, 'clientId is a required param of getEmailChangeToken()');

    const query = querystring.stringify({ brandId });
    const url = `${baseUrl}${language}-${country.toLowerCase()}/account/@self/change-request/email?${query}`;

    return labelRequest(authenticatedRequest(new Request(url, { method: 'POST' }), uberToken, clientId, clientSecret), 'getEmailChangeToken');
}
